import React from "react";
import { MigrationStatus } from "../enums/MigrationStatus";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { t } from "i18next";
import { faCircleCheck, faOctagonXmark } from "@fortawesome/pro-solid-svg-icons";

const MigrationRowStatusIcon = ({ status }: { status: string }) => {
  switch (status) {
  case MigrationStatus.Complete:
    return <FontAwesomeIcon title={t`Imported`} className="text-gray-300 h-6 w-6" icon={faCircleCheck} />;
  case MigrationStatus.Ready:
    return <FontAwesomeIcon title={t`Ready to Import`} className="text-success h-6 w-6" icon={faCircleCheck} />;
  default:
    return <FontAwesomeIcon title={t`Incomplete`} className="text-danger h-6 w-6" icon={faOctagonXmark} />;
  }
};

export default MigrationRowStatusIcon;

export const UploadStatusIcon = MigrationRowStatusIcon;